import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/services', label: '事業内容' },
    { path: '/about', label: '会社概要' },
    { path: '/recruit', label: '求人情報' },
    { path: '/blog', label: 'ブログ・新着情報' },
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 sm:h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center flex-shrink-0">
              <h1 className="text-sm sm:text-base lg:text-lg xl:text-xl font-bold text-navy-800 whitespace-nowrap">
                ヘルパーステーションおかやま
              </h1>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-3 xl:space-x-5">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm font-medium text-navy-800 hover:text-coral-500 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="tel:086-012-3456"
                className="flex items-center space-x-2 bg-coral-500 text-white px-4 xl:px-5 py-2.5 rounded-full hover:bg-coral-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-base"></i>
                <span className="font-medium text-sm">086-012-3456</span>
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center text-navy-800 cursor-pointer"
              aria-label="メニュー"
            >
              <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ duration: 0.3 }}
            className="fixed top-16 sm:top-20 right-0 bottom-0 w-full sm:w-80 bg-navy-800/98 backdrop-blur-sm z-40 lg:hidden overflow-y-auto"
          >
            <nav className="flex flex-col p-6 space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-white text-base font-medium py-3 border-b border-white/10 hover:text-coral-400 transition-colors"
                >
                  {link.label}
                </Link>
              ))}
              <a
                href="tel:086-012-3456"
                className="flex items-center justify-center space-x-2 bg-coral-500 text-white px-6 py-4 rounded-full hover:bg-coral-600 transition-colors mt-4 cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                <span className="font-medium">086-012-3456</span>
              </a>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
